import { useState } from 'react'
import { useAppState, useAppDispatch } from '../Context'
import ajax from '@common/ajax'

function LocationZip() {
  const [showError, setShowError] = useState(false)
  const dispatch = useAppDispatch()
  const { endpoint, userZip } = useAppState()

  const handleSubmit = async (e) => {
    e.preventDefault()

    setShowError(false)

    const zip = new FormData(e.target).get('zip')

    dispatch({ type: 'setIsLoading', payload: true })

    const res = await ajax.get(`${endpoint}locationsbyzip?zip=${zip}`).json()

    dispatch({ type: 'setIsLoading', payload: false })

    if (res.success) {
      dispatch({ type: 'setSelectedLocation', payload: null })
      dispatch({ type: 'setLocations', payload: res.locations })
      dispatch({ type: 'setUserCoords', payload: res.position })
    } else {
      setShowError(true)
    }
  }

  const handleClear = () => {
    setShowError(false)
    dispatch({ type: 'setUserZip', payload: '' })
    dispatch({ type: 'setUserCoords', payload: null })
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex relative">
        <input
          type="text"
          name="zip"
          placeholder="Enter Zip"
          className="px-4 pr-20 w-full text-base border border-r-0 py-[13px]"
          value={userZip}
          onChange={(e) => {
            dispatch({ type: 'setUserZip', payload: e.target.value })
          }}
        />
        <button type="submit" className="flex-shrink-0 px-4 w-24 text-base font-medium btn-fill-secondary">
          Find
        </button>

        {userZip !== '' && (
          <button type="button" className="absolute top-0 right-24 w-12 h-full" onClick={handleClear}>
            <span className="sr-only">Clear Field</span>
            <svg viewBox="0 0 24 24" aria-hidden="true" className="m-auto w-1/3 h-1/3">
              <path
                fill="currentColor"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
          </button>
        )}
      </div>

      {showError && <div className="py-2 text-sm font-medium">Please enter a valid zip code</div>}
    </form>
  )
}

export default LocationZip
